<template>
  <div class="card-order">
    <v-card
      class="card-order-content"
      elevation="2"
    >
      <div class="card-order-main">
        <div class="order-info order-title-info">
          {{ $t('components.card_order.order',{ id: order.id }) }}
        </div>
        <div class="order-info">
          {{ $t('components.card_order.status') }}
          <div
            :class="['info-content', 'status-badge', statusClass]"
          >
            {{ order.status_text }}
          </div>
        </div>
        <div class="order-info">
          {{ $t('components.card_order.created_at') }}
          <div class="info-content">
            <v-icon
              small
              class="info-icon"
            >
              mdi-calendar-month-outline
            </v-icon>
            {{ order.created_at }}
          </div>
        </div>
        <div class="order-info">
          {{ $t('components.card_order.total_value') }}
          <div class="info-content">
            <v-icon
              small
              class="info-icon"
            >
              mdi-cash-multiple
            </v-icon>
            {{ formattedTotalValue }}
          </div>
        </div>
        <div class="card-order-action">
          <v-btn
            outlined
            color="primary"
            class="order-button"
            :disabled="orderCancelled"
            @click="orderShow"
          >
            <v-icon left>
              mdi-eye-outline
            </v-icon>
            {{ $t('components.card_order.show_order') }}
          </v-btn>
        </div>
      </div>

      <order-certificate-summary
        :order="order"
        class="certificate-summary"
      />
    </v-card>
  </div>
</template>
<script>
import formatMoney from '@/mixins/formatMoney';
import OrderCertificateSummary from '@/components/orders/OrderCertificateSummary.vue';

import { OrderStatus } from '@/enums/OrderStatus';

export default {
  name: 'CardOrder',
  components: {
    OrderCertificateSummary,
  },
  mixins: [formatMoney],
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    formattedTotalValue() {
      return this.formatMoney(Number(this.order.total_value));
    },

    orderCancelled() {
      return this.order.status === OrderStatus.CANCELLED;
    },

    statusClass() {
      if (this.order.status === OrderStatus.PAID) {
        return 'paid-style';
      }

      if (this.order.status === OrderStatus.CANCELLED) {
        return 'cancelled-style';
      }

      return 'pending-style';
    },
  },
  methods: {
    orderShow() {
      this.$router.push({ name: 'order', params: { id: this.order.id } });
    },
  },
};
</script>
<style lang="scss" scoped>
  .card-order {
    padding: 0 0 20px 0;

    .card-order-content {
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      font-size: 1em;
      gap: 20px;
      padding: 20px;

      .card-order-main {
        align-items: flex-start;
        column-gap: 24px;
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr)) auto;
        width: 100%;
      }

      .order-info {
        color: rgba($color_dark, 0.72);
        display: flex;
        flex-direction: column;
        font-weight: bold;
        min-width: 0;

        .info-content {
          align-items: center;
          color: $color_dark;
          display: flex;
          gap: 6px;
          font-weight: 100;
          margin-top: 8px;
        }

        .info-icon {
          color: rgba($color_dark, 0.48);
        }

        .status-badge {
          align-items: center;
          background: $color_background_pending;
          border-radius: 6px;
          color: $color_pending;
          display: inline-flex;
          align-self: flex-start;
          font-size: 0.95em;
          font-weight: 600;
          margin-top: 8px;
          padding: 6px 12px;
          width: fit-content;

          &::before {
            background: currentColor;
            border-radius: 50%;
            content: '';
            display: block;
            height: 8px;
            margin-right: 10px;
            width: 8px;
          }

          &.paid-style {
            background: $color_background_approved;
            color: $color_approved;
          }

          &.cancelled-style {
            background: $color_background_disapproved;
            color: $color_disapproved;
          }
        }
      }

      .order-title-info {
        color: $color_dark;
        font-size: 1.1em;
      }

      .card-order-action {
        align-self: center;
        justify-self: end;
      }

      .order-button {
        border-radius: 10px;
        font-size: 1em;
        height: 48px !important;
        text-transform: none;
        width: 200px;
      }

      .certificate-summary {
        margin-top: 4px;
      }

      @media (max-width: 1200px) {
        .card-order-main {
          grid-template-columns: repeat(2, minmax(0, 1fr));
          row-gap: 16px;
        }

        .card-order-action {
          justify-self: start;
        }
      }
    }
  }

</style>
